// src/services/buyForMeApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../../config';

export const buyForMeApi = createApi({
    reducerPath: 'buyForMeApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_BASE_URL + "/api/app/invoice",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        submitBuyForMe: builder.mutation({
            query: (data) => ({
                url: '/createBuyForMe',
                method: 'POST',
                body: data,
            }),
        }),
        setPickupPoint: builder.mutation({
            query: (data) => ({
                url: `prefer-pickup`,
                method: "POST",
                body: data
            }),
            invalidatesTags: ["common"],
        }),
    }),
});

export const { useSubmitBuyForMeMutation, useSetPickupPointMutation } = buyForMeApi;
